export class DraggableTypes {
    static ACTION = '_action';
    static KEY = '_key';
}
